module.exports = __webpack_public_path__ + "img/zoom-logo-square.79854553.png";